import { render, staticRenderFns } from "./CurrencyRate.vue?vue&type=template&id=4fea8386&scoped=true&"
import script from "./CurrencyRate.vue?vue&type=script&lang=js&"
export * from "./CurrencyRate.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyRate.vue?vue&type=style&index=0&id=4fea8386&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fea8386",
  null
  
)

export default component.exports